import { Link } from "react-router-dom";
import PersonalDataset from "datasets/types/interfaces/personal-dataset";
import { Skeleton } from "~/components/ui/skeleton";
import { ROUTE_NOVA_PERSONAL_DATASET } from "~/router/constants";
import { PersonalDatasetIcon } from "./PersonalDatasetIcon";

const PERSONAL_DATASET_NAME = "My Dataset";

interface PersonalDatasetCardProps {
  dataset?: PersonalDataset;
  isLoading?: boolean;
}

// Always pinned above the regular dataset list. Styled with the same neutral
// chrome as a regular dataset card — the primary-tinted icon is the only accent —
// since it's not a dataset a user shares or is granted access to.
export const PersonalDatasetCard = ({ dataset, isLoading }: PersonalDatasetCardProps) => {
  if (isLoading) {
    return (
      <Skeleton data-testid="personal-dataset-card-skeleton" className="h-20 w-full rounded-lg" />
    );
  }

  if (!dataset) {
    return null;
  }

  return (
    <Link
      to={ROUTE_NOVA_PERSONAL_DATASET}
      data-testid="personal-dataset-card"
      className="group block rounded-lg border border-border bg-card transition-colors duration-150 hover:bg-muted/50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
    >
      <div className="flex items-center gap-4 px-6 py-5">
        <PersonalDatasetIcon size={28} />
        <div className="min-w-0 flex-1">
          <h3 className="truncate text-base font-semibold text-foreground">
            {PERSONAL_DATASET_NAME}
          </h3>
          <p className="text-xs text-muted-foreground">
            Your private workspace for draft tables and views
          </p>
        </div>
      </div>
    </Link>
  );
};
